import { useQuery } from '@tanstack/react-query';

import { API_MAX_LIMIT } from '@/constants';
import { mediaManagerClient } from '@/lib/axios';
import { QueryConfig } from '@/lib/react-query';
import { PaginatedResponse, ParamsWithPagination } from '@/types/api';

import { ChannelFilters, ChannelType } from '../types';

import { channelsQueryKeys } from './query-keys';

export async function getChannels(
  params?: ParamsWithPagination<ChannelFilters>
): Promise<PaginatedResponse<ChannelType>> {
  return mediaManagerClient.get('/api/v1/channels', {
    params: {
      limit: params?.limit ?? API_MAX_LIMIT,
      offset: params?.offset,
      search: params?.search,
      id__in: params?.idIn?.join(','),
      media_type__in: params?.mediaTypeIn?.join(','),
      is_parent_channel: params?.isParentChannel,
      parent_channel_id: params?.parentChannelId,
      scope: params?.scope,
      country_code: params?.countryCode,
      region_code: params?.regionCode,
      subregion_code: params?.subregionCode,
      updated_by__in: params?.updatedByIn?.join(','),
      state: params?.state,
      order_by: params?.order_by,
      program_broadcast_start_datetime__gte: params?.programBroadcastStartDatetimeGte,
      program_broadcast_start_datetime__lte: params?.programBroadcastStartDatetimeLte,
      segment_start_datetime__gte: params?.segmentStartDatetimeGte,
      segment_end_datetime__lte: params?.segmentEndDatetimeLte,
      clip_start_datetime__gte: params?.clipStartDatetimeGte,
      clip_end_datetime__lte: params?.clipEndDatetimeLte,
    },
  });
}

type QueryFnType = typeof getChannels;

interface UseSegmentsParams {
  config?: QueryConfig<QueryFnType>;
  params?: ParamsWithPagination<ChannelFilters>;
}

export function useChannels({ config, params }: UseSegmentsParams = {}) {
  return useQuery({
    ...config,
    queryKey: channelsQueryKeys.list(params),
    queryFn: () => getChannels(params),
  });
}
